import { useTranslation } from 'react-i18next'
import eurologo from 'assets/img/1200px-Logo-europass.png'
import unetLogo from 'assets/img/chu.svg'

import { Layout } from 'components'
import ProfilePage from 'pages/ProfilePage/ProfilePage'
import { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { useReactToPrint } from 'react-to-print'
import { getPersonalEmployee } from 'service/PersonalCardService'
import { setPersonalInfo } from 'store/slices/PersonalCard'
import userInfo from 'utils/userInfo'
import styles from './Europass.module.scss'
const FinalEuropass = () => {
  const { t } = useTranslation('common')

  const user = userInfo()
  const info = useSelector((state) => state.personalcard.personal_info)
  const check = useSelector((state) => state.personalcard.Europass)
  const user_changes = useSelector((state) => state.personalcard.user_change)
  const [logo, setLogo] = useState(false)
  const [euro, setEuro] = useState(false)
  const [polit, setPolit] = useState(false)
  const [unet, setUnet] = useState(false)

  const navigate = useNavigate()
  const componentRef = useRef()
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: 'Simpleraport',
  })

  let data
  const dispatch = useDispatch()
  const [render, setRender] = useState(false)
  const getDataStart = async () => {
    try {
      let response = await getPersonalEmployee(data, 'ru')

      dispatch(
        setPersonalInfo({
          personal_info: response.data,
        }),
      )
    } catch (error) {}
  }

  useEffect(() => {
    getDataStart()

    setRender(false)
  }, [render])

  return (
    <Layout>
      <div className={styles.personal_wrapper2}>
        <div className={styles.header}>
          <h3 className={styles.Personal_Card}>{t('europass.personal_card')}</h3>
          <div className={styles.header_body}>
            
            <button
              className={styles.btn1}
        
              onClick={handlePrint}
            >
              {t('tasks.print')}
            </button>
          </div>
        </div>

        <button
          onClick={() => navigate('/europass')}
          style={{ width: '100px', marginRight: '30px' }}
          className={styles.btn1}
        >
          Назад
        </button>

        <button
          onClick={() => {
            setLogo(true)
          }}
          className={styles.btn1}
        >
          Выберите Логотип
        </button>

        {logo ? (
          <div
            style={{
              marginTop: '20px',
              width: '240px',
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <img
              onClick={() => {
                setPolit(false)
                setEuro(true)
                setUnet(false)
              }}
              style={{ width: '100px', cursor: 'pointer' }}
              src={eurologo}
              alt=""
            />
          
            <img
              onClick={() => {
                setPolit(false)
                setEuro(false)
                setUnet(true)
              }}
              style={{ width: '120px', cursor: 'pointer' }}
              src={unetLogo}
              alt=""
            />
          </div>
        ) : null}
        <div
          className={styles.body2}
          style={{
            margin: '0 auto',
            border: 'none',
            zIndex: '5',
            maxHeight: '3500px',
            display: 'flex',
            flexDirection: 'column',
            overflowX: 'auto',
          }}
          ref={componentRef}
        >
          <div
            style={{
              paddingTop: '45px',
              justifyContent: 'center',
              display: 'flex',
              gap: '200px',
            }}
          >
            <div style={{ width: '150px' }}>
            

              {euro ? (
                <img
                  style={{
                    width: '150px',
                    height: '190px',
                    zIndex: '2',
                    objectFit: 'contain',
                  }}
                  src={eurologo}
                  alt=""
                />
              ) : null}

              {unet ? (
                <img
                  style={{
                    width: '150px',
                    height: '190px',
                    zIndex: '2',
                    objectFit: 'contain',
                  }}
                  src={unetLogo}
                  alt=""
                />
              ) : null}
            </div>
            <div>
              <img
                src={user.image}
                alt=""
                style={{
                  width: '180px',
                  
                  zIndex: '2',
                  objectFit: 'cover',
                  border: '1px solid #eee',
                }}
              />
            </div>
          </div>

          <div style={{ display: 'flex', margin: 'auto', gap: '20px' }}>
            <div className={styles.body_left} style={{ zIndex: '5', gap: '0' }}>
              {euro ? (
                <div className={styles.body_list}>
                  <h2 className={styles.body_list_left}>
                    Europass Curriculum Vitae
                  </h2>
                </div>
              ) : null}
             
              {unet ? (
                <div className={styles.body_list}>
                  <h2 className={styles.body_list_left}>
                  CHU Curriculum Vitae
                  </h2>
                </div>
              ) : null}
              {euro || polit || unet ? null : <h2>ㅤㅤㅤ</h2>}
              <div className={styles.body_list}>
                <h3
                  style={{ fontSize: '22px' }}
                  className={styles.body_list_left}
                >
                  {t('europass.personal_info')}
                </h3>
              </div>
              
              <div className={styles.body_info}>
                <h4 className={styles.body_list_left}>{t('common.fullName')}</h4>
                <p style={{ fontSize: '16px' }}>
                  {check.first_name} {check.surname}
                </p>
              </div>

              <div className={styles.body_info}>
                {info?.residence_place?.street ? (
                  <h4 className={styles.body_list_left}>{t('common.address')}</h4>
                ) : null}
                {info?.residence_place?.street}
              </div>

              <div className={styles.body_info}>
                {user_changes?.numberPhone ? (
                  <h4 className={styles.body_list_left}>{t('europass.mobile')}</h4>
                ) : null}
                {user_changes?.numberPhone ? <p>{user?.numberPhone}</p> : null}
              </div>

              <div className={styles.body_info}>
                {user_changes?.email ? (
                  <h4 className={styles.body_list_left}>{t('europass.email')}</h4>
                ) : null}
                {user_changes?.email ? <p>{user?.email}</p> : null}
              </div>

              <div className={styles.body_info}>
                
                <h4 className={styles.body_list_left}>{t('europass.nationality')}</h4>
                <p>{info?.citizenship}</p>
              </div>

              <div className={styles.body_info}>
                {user_changes?.data_of_birth ? (
                  <h4 className={styles.body_list_left}>{t('user.birth_date')}</h4>
                ) : null}
                {user_changes?.data_of_birth ? (
                  <p>{user?.data_of_birth}</p>
                ) : null}
              </div>

              <div className={styles.body_info}>
                {check?.education ? (
                  <div>
                    <div className={styles.body_list}>
                      <h2 className={styles.body_list_left}>{t('students.step_education')}</h2>
                    </div>

                    <div className={styles.body_list}>
                      <h4 className={styles.body_list_left}>{t('europass.university')}</h4>
                      <p>{check?.education?.institution}</p>
                    </div>

                    <div className={styles.body_list}>
                      <h4 className={styles.body_list_left}>{t('archive.col_faculty')}</h4>
                      <p>{check?.education?.department}</p>
                    </div>
                    <div className={styles.body_list}>
                      <h4 className={styles.body_list_left}>{t('archive.col_specialty')}</h4>
                      <p>{check?.education?.academic_rank}</p>
                    </div>
                    <div className={styles.body_list}>
                      <h4 className={styles.body_list_left}>{t('europass.study_start')}</h4>
                      <p>{check?.education?.entered}</p>
                    </div>

                    <div className={styles.body_list}>
                      <h4 className={styles.body_list_left}>{t('europass.study_end')}</h4>
                      <p>{check?.education?.graduated}</p>
                    </div>
                  </div>
                ) : null}
              </div>

              {!check?.ranks || check?.ranks.length === 0 ? null : (
                <div>
                  <div className={styles.body_list}>
                    <h2 className={styles.body_list_left}>
                      {t('europass.diplomatic_rank_short')}
                    </h2>
                  </div>
                  <div className={styles.body_list}>
                    <h4 className={styles.body_list_left}>{t('common.name')}</h4>
                    <p>{check?.ranks[0]?.title}</p>
                  </div>
                  <div className={styles.body_list}>
                    <h4 className={styles.body_list_left}>{t('europass.rank')}</h4>
                    <p>{check?.ranks[0]?.rank}</p>
                  </div>
                  <div className={styles.body_list}>
                    <h4 className={styles.body_list_left}>{t('common.date')}</h4>
                    <p>{check?.ranks[0]?.assigned}</p>
                  </div>
                  
                  
                </div>
              )}

              <div className={styles.body_info}>
                {check?.military_registration ? (
                  <div>
                    <div className={styles.body_list}>
                      <h2 className={styles.body_list_left}>{t('auto.europassmilitary_europassmilitary.k1')}</h2>
                    </div>
                    <div className={styles.body_list}>
                      <h4 className={styles.body_list_left}>
                        {t('europass.fitness')}
                      </h4>
                      {check?.military_registration.is_fit ? (
                        <h4 style={{}}>{t('europass.fit')}</h4>
                      ) : (
                        <h4 style={{}}>{t('europass.negode')}</h4>
                      )}
                    </div>
                    <div className={styles.body_list}>
                      <h4 className={styles.body_list_left}>
                        {t('europass.draft_board')}
                      </h4>
                      <p>{check?.military_registration?.draft_board}</p>
                    </div>
                    <div className={styles.body_list}>
                      <h4 className={styles.body_list_left}>{t('europass.composition')}</h4>
                      <p>{check?.military_registration?.composition}</p>
                    </div>
                    <div className={styles.body_list}>
                      <h4 className={styles.body_list_left}>{t('europass.vus')}</h4>
                      <p>{check?.military_registration?.rank}</p>
                    </div>
                    <div className={styles.body_list}>
                      <h4 className={styles.body_list_left}>{t('europass.military_rank')}</h4>
                      <p>{check?.military_registration?.specialty}</p>
                    </div>
                    <div className={styles.body_list}>
                      <h4 className={styles.body_list_left}>{t('europass.troop_kind')}</h4>
                      <p>{check?.military_registration?.troop_kind}</p>
                    </div>
                  </div>
                ) : null}
              </div>

              <div className={styles.body_info}>
                {check?.employment ? (
                  <div>
                    <div className={styles.body_list}>
                      <h2 className={styles.body_list_left}>
                        {t('europass.employment_short')}
                      </h2>
                    </div>
                    <div className={styles.body_list}>
                      <h4 className={styles.body_list_left}>{t('archive.col_specialty')}</h4>
                      <p>{info?.employment?.professional_experience}</p>
                    </div>

                    <div className={styles.body_list}>
                      <h4 className={styles.body_list_left}>{t('europass.total')}</h4>
                      <p>{info?.employment?.total_experience}</p>
                    </div>
                    <div className={styles.body_list}>
                      <h4 className={styles.body_list_left}>{t('europass.public_service')}</h4>
                      <p>{info?.employment?.public_service_experience}</p>
                    </div>
                    <div className={styles.body_list}>
                      <h4 className={styles.body_list_left}>
                        {t('europass.private_service')}
                      </h4>
                      <p>{info?.employment?.private_service_experience}</p>
                    </div>
                  </div>
                ) : null}
              </div>

              <div className={styles.body_info}>
                {!check?.trainings || check?.trainings.length === 0 ? null : (
                  <div>
                    <div className={styles.body_list}>
                      <h2 className={styles.body_list_left}>
                        {t('europass.training')}
                      </h2>
                    </div>

                    <div className={styles.body_list}>
                      <h4 className={styles.body_list_left}>{t('diploma.topic')}</h4>
                      <p>{info?.trainings[0]?.title}</p>
                    </div>
                    <div className={styles.body_list}>
                      <h4 className={styles.body_list_left}>{t('archive.info_period_start')}</h4>
                      <p>{info?.trainings[0]?.started}</p>
                    </div>
                    <div className={styles.body_list}>
                      <h4 className={styles.body_list_left}>{t('calendar.end')}</h4>
                      <p>{info?.trainings[0]?.ended}</p>
                    </div>

                    <div className={styles.body_list}>
                      <h4 className={styles.body_list_left}>{t('europass.training_kind')}</h4>
                      <p>{info?.trainings[0]?.kind}</p>
                    </div>
                    <div className={styles.body_list}>
                      <h4 className={styles.body_list_left}>{t('europass.doc_type')}</h4>
                      <p>{info?.trainings[0]?.certification_type}</p>

                      
                    </div>
                  </div>
                )}
              </div>

              <div className={styles.body_info}>
                {check?.employment === true &&
                check?.employment?.experiences.length !== 0 ? (
                  <div>
                    <div className={styles.body_list}>
                      <h2 className={styles.body_list_left}>
                        {t('europass.performed_work')}
                      </h2>
                    </div>

                    <div className={styles.body_list}>
                      <h4 className={styles.body_list_left}>
                        {t('europass.position')}
                      </h4>
                      <p>{info?.employment?.experiences[0].position}</p>
                    </div>
                    <div className={styles.body_list}>
                      <h4 className={styles.body_list_left}>{t('europass.staff')}</h4>
                      <p>{info?.employment?.experiences[0].organization}</p>
                    </div>
                    <div className={styles.body_list}>
                      <h4 className={styles.body_list_left}>
                        {t('europass.organization_name')}
                      </h4>
                      <p>{info?.employment?.experiences[0].organization}</p>
                    </div>

                    <div className={styles.body_list}>
                      <h4 className={styles.body_list_left}>{t('europass.work_start')}</h4>
                      <p>{info?.employment?.experiences[0].started}</p>
                    </div>

                    <div className={styles.body_list}>
                      <h4 className={styles.body_list_left}>{t('europass.work_end')}</h4>
                      <p>{info?.employment?.experiences[0].ended}</p>
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default FinalEuropass
